var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import InputLabel from '../InputLabel';
import { StyledLabel, StyledStatusMessage, StyledFormField } from './FormField.styled';
import { DATA_ATTRS } from '../../utils/gtm';
import { generateUniqueId } from '../../utils/generateUniqueId';
const defaultProps = {
  size: 'large',
  status: {
    type: 'default'
  }
};

const FormField = _a => {
  var {
    label,
    id,
    component: InputComponent,
    isFloatingLabel,
    isShrink,
    data,
    selectedId,
    isCenteredPlaceholder,
    skin,
    labelSize,
    isDisabled,
    size = defaultProps.size,
    status = defaultProps.status
  } = _a,
      otherInputProps = __rest(_a, ["label", "id", "component", "isFloatingLabel", "isShrink", "data", "selectedId", "isCenteredPlaceholder", "skin", "labelSize", "isDisabled", "size", "status"]);

  const inputId = id || generateUniqueId();
  return React.createElement(StyledFormField, null, label && !isFloatingLabel && React.createElement(StyledLabel, {
    size: labelSize
  }, React.createElement(InputLabel, {
    htmlFor: inputId,
    size: labelSize,
    skin: skin,
    isDisabled: isDisabled
  }, label)), React.createElement(InputComponent, Object.assign({
    status: status.type,
    isFloatingLabel: isFloatingLabel,
    centeredPlaceholder: isCenteredPlaceholder,
    size: size,
    theme: skin,
    skin: skin,
    disabled: isDisabled,
    isDisabled: isDisabled,
    data: data,
    selectedId: selectedId,
    key: "input",
    label: isFloatingLabel ? label : undefined,
    labelSize: labelSize,
    isShrink: isShrink,
    dataAttrs: otherInputProps[DATA_ATTRS],
    inputId: inputId
  }, otherInputProps)), (status === null || status === void 0 ? void 0 : status.message) && React.createElement(StyledStatusMessage, {
    status: status,
    skin: skin,
    size: size,
    isDisabled: isDisabled
  }, status.message));
};

export default FormField;